import "twin.macro";

import { useMemo, useState } from "react";
import { LinkProps, Outlet } from "react-router-dom";

import Breadcrumb from "@/components/Breadcrumb";
import ClientTabs from "@/components/NavigationTabs";
import { PageContent, PageTitle } from "@/components/page";
import { useClientContext } from "@/data-loaders/client-data-loader";

const Client = () => {
  const { _id: clientId, name } = useClientContext();

  type BreadcrumbItem = Pick<LinkProps, "children" | "to">;
  const defaultItems: BreadcrumbItem[] = useMemo(
    () => [
      { to: "/", children: "Clients" },
      { to: `/clients/${clientId}/informations`, children: name },
    ],
    [clientId, name]
  );
  const [breadcrumbItems, setBreadcrumbItems] =
    useState<BreadcrumbItem[]>(defaultItems);
  const [pageTitle, setPageTitle] = useState<string>(name);
  const [showClientTabs, setShowClientTabs] = useState<boolean>(true);

  return (
    <PageContent tw="sm:ml-8 p-4 sm:p-8">
      <div tw="flex flex-col gap-4">
        <Breadcrumb items={breadcrumbItems} />

        <PageTitle tw="text-secondary-950">{pageTitle}</PageTitle>

        {showClientTabs && <ClientTabs />}
      </div>
      <Outlet
        context={{
          breadcrumbItems,
          setBreadcrumbItems,
          defaultItems,
          pageTitle,
          setPageTitle,
          showClientTabs,
          setShowClientTabs,
        }}
      />
    </PageContent>
  );
};

export default Client;
